import { Route, Routes } from 'react-router-dom';

import './globalStyle.css';

import Home from './pages/Home';
import About from './pages/About';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Rankings from './pages/Rankings';
import Videos from './pages/Videos';

function App() {
  // //@ts-ignore
  // const getData = [];
  // //@ts-ignore
  // const [data, setData]: [any, (posts: any) => void] = useState(getData);
  // const [error, setError]: [string, (error: string) => void] = useState("");

  // useEffect(() => {
  //   api.get("ibge/city", {
  //     headers: {
  //       "Content-Type": "application/json"
  //     },
  //   }).then(response => {
  //     setData(response.data);
  //     console.log(response.data);
  //   });
  // }, []);

  return (
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rankings" element={<Rankings />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/sobre" element={<About />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
